import { BaseTextFieldBox } from "@/shared/components/text-box/base-text-box";
import { BaseDescriptionTextFieldBox } from "@/shared/components/text-box/base-description-text-box";
import React, { useEffect, useState } from "react";
import { useInputValidation, ValidationRule } from "@/shared/hooks/use-input-validation";

interface Props {
  id?: string;
  className?: string;
  title?: string;
  placeholder?: string;
  value?: string;
  initialValue?: string;
  onChange: (newValue: string) => void;
  errorMessage?: string;
  labelEnable?: boolean;
  isDisabled?: boolean;
  isReadOnly?: boolean;
  descriptionType?: boolean;
  maxLength?: number;
  validationRule?: ValidationRule;
}


export const SimpleForm = (props: Props) => {
  const {
    id = "",
    className="",
    value,
    initialValue,
    onChange,
    errorMessage = "",
    title = "",
    placeholder = "",
    labelEnable = false,
    isDisabled,
    isReadOnly = false,
    descriptionType = false,
    maxLength = 50,
    validationRule = "deleteOver4Bytes",
  } = props;

  const { validate } = useInputValidation(validationRule);

  const [showValue, setShowValue] = useState(() => validate(initialValue ?? "", false));
  const [isComposing, setIsComposing] = useState(false);
  const [whitespaceOnlyError, setWhitespaceOnlyError] = useState("");

  useEffect(() => {
    if (value !== undefined) {
      setShowValue(value);
    }
  }, [value]);

  const applyInputValue = (rawValue: string, composing = isComposing) => {
    const formattedValue = validate(rawValue, composing);
    const isWhitespaceOnlyInput = !composing && formattedValue !== "" && formattedValue.trim() === "";
    // 入力完了後は空白のみを空文字として扱い、送信時バリデーションで検出できるようにする
    const normalizedValue = isWhitespaceOnlyInput ? "" : formattedValue;
    setWhitespaceOnlyError(isWhitespaceOnlyInput ? "スペースのみでは登録できません。文字を入力してください。" : "");
    setShowValue(normalizedValue);
    onChange(normalizedValue);
  };

  const mergedErrorMessage = whitespaceOnlyError || errorMessage;

  const onChangeInputValue = (e: React.ChangeEvent<HTMLInputElement>) => {
    applyInputValue(e.target.value);
  };

  const handleCompositionEnd = () => {
    setIsComposing(false);
    // IME確定時は強制的に検証ルールを適用
    applyInputValue(showValue, false);
  };

  const handleBlur = () => {
    // フォーカスが外れた際にIME未確定状態の値を強制的に検証する
    if (isComposing) {
      setIsComposing(false);
    }
    applyInputValue(showValue, false);
  };


  if (descriptionType) {
    return (
      <BaseDescriptionTextFieldBox
        id={id}
        className={className}
        title={title}
        placeholder={placeholder}
        value={showValue}
        type="text"
        onChange={onChangeInputValue}
        errorMessage={mergedErrorMessage}
        labelEnable={labelEnable}
        isDisabled={isDisabled}
        isReadOnly={isReadOnly}
        maxLength={maxLength}
        onCompositionStart={() => setIsComposing(true)}
        onCompositionEnd={handleCompositionEnd}
        onBlur={handleBlur}
      />
    )
  } else {
    return (
      <BaseTextFieldBox
        id={id}
        className={className}
        title={title}
        placeholder={placeholder}
        value={showValue}
        type="text"
        onChange={onChangeInputValue}
        errorMessage={mergedErrorMessage}
        labelEnable={labelEnable}
        isDisabled={isDisabled}
        isReadOnly={isReadOnly}
        maxLength={maxLength}
        onCompositionStart={() => setIsComposing(true)}
        onCompositionEnd={handleCompositionEnd}
        onBlur={handleBlur}
      />
    )
  }
};
